import {connect} from 'react-redux'
import {Icon, Loader, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Col, NavItem, NavLink, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as subjektActions from "../../actions/subjektActions";
import {getIdFromProps} from "../../utils/utils";
import {LinkContainer} from "react-router-bootstrap";
import SpolecnostZakladniUdajePanel from "../../components/SpolecnostZakladniUdajePanel";
import SpolecnostPobockaVydejPanel from "../../components/SpolecnostPobockaVydejPanel";
import ZamestnanciPanel from "../../components/ZamestnanciPanel";
import AdresyPanel from "../../components/AdresyPanel";
import KartyPanel from "../../components/KartyPanel";
import NastaveniObjednavkyPanel from "../../components/NastaveniObjednavkyPanel";
import {ADMIN_BASE_PATH, SPOLECNOSTI_PATH} from "../../const/routes";
import NakladovaStrediskaPanel from "../../components/NakladovaStrediskaPanel";
import * as ciselnikActions from "../../actions/ciselnikActions";
import * as opravneniActions from "../../actions/opravneniActions";
import * as EnumRole from "../../api/gen/cgo/EnumRole";
import './SpolecnostPage.scss';
import {withTranslation, WithTranslation} from "react-i18next";

const {storeFromArea} = utils;

/**
 * Stránka administrace - detail konkrétní společnosti
 */
class SpolecnostPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const spolecnostId = getIdFromProps(this.props);
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(subjektActions.fetchSpolecnostDetailIfNeeded(spolecnostId));
        this.props.dispatch(subjektActions.fetchSpolecnostRightsIfNeeded(spolecnostId));
        this.props.dispatch(subjektActions.fetchUzivateleSpolecnostIfNeeded(spolecnostId));
        this.props.dispatch(subjektActions.fetchAdresySpolecnostIfNeeded(spolecnostId));
        this.props.dispatch(subjektActions.fetchKartySpolecnostIfNeeded(spolecnostId, null));
        this.props.dispatch(subjektActions.fetchSpolecnostPobockaVydejIfNeeded(spolecnostId));
        this.props.dispatch(subjektActions.fetchSpolecnostPobockaVydejVcetneVydejniIfNeeded(spolecnostId));
        this.props.dispatch(ciselnikActions.fetchNakladovaStrediskaIfNeeded(spolecnostId));
    };

    render() {
        const {
            loggedInUser, spolecnostDetail, spolecnostRightsDetail, uzivateleSpolecnostList, adresySpolecnostList, kartySpolecnostList,
            nakladovaStrediskaList, spolecnostPobockyVydejList, t
        } = this.props;

        if (!loggedInUser.fetched || !spolecnostRightsDetail.fetched || !spolecnostDetail.fetched) {
            return <Loader />;
        }

        const spolecnost = spolecnostDetail.data;
        const spolecnostRights = spolecnostRightsDetail.data;
        const role = loggedInUser.data.role;
        const {zpusobDopravaVychozi, zpusobPlatbaVychozi, pobockaVydej, preskocitKontakt, preskocitDoprava, preskocitPlatba, naklStrediskoTextem, povinneNaklStredisko} = spolecnost;

        return <AdminPage
            title={spolecnost.nazevSpolecnost}
            subtitle={t('admin.company_var_name',{companyName: spolecnost.nazevSpolecnost})}
            noScroll={true}
            tabs={[
                <NavItem key="1">
                    <LinkContainer replace to={`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/${getIdFromProps(this.props)}`}>
                        <NavLink active={true}><Icon icon="home" title={t('admin.company')} /></NavLink>
                    </LinkContainer>
                </NavItem>,
                <NavItem key="2">
                    <LinkContainer replace to={`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/${getIdFromProps(this.props)}/ceniky`}>
                        <NavLink active={false}>{t('admin.price_list_many')}</NavLink>
                    </LinkContainer>
                </NavItem>
            ]}
            content={<Row className={"spolecnost-page"}>
                <Col sm={6}>
                    <SpolecnostZakladniUdajePanel
                        spolecnost={spolecnost}
                        readOnly={!spolecnostRights.spolecnostEdit}
                    />
                    {adresySpolecnostList.fetched ?
                        <AdresyPanel
                            adresyList={adresySpolecnostList.rows}
                            spolecnostId={spolecnost.id}
                            readOnly={!spolecnostRights.adresaEdit}
                        /> : <Loader />
                    }
                    {uzivateleSpolecnostList.fetched ?
                        <ZamestnanciPanel
                            zamestnanciList={uzivateleSpolecnostList.rows}
                            spolecnostId={spolecnost.id}
                            spolecnostRights={spolecnostRights}
                        /> : <Loader />
                    }
                </Col>
                <Col sm={6}>
                    <NastaveniObjednavkyPanel
                        nastaveniObjednavky={{
                            zpusobDopravaVychozi,
                            zpusobPlatbaVychozi,
                            pobockaVydej,
                            preskocitKontakt,
                            preskocitDoprava,
                            preskocitPlatba,
                            naklStrediskoTextem,
                            povinneNaklStredisko
                        }}
                        spolecnostId={spolecnost.id}
                        readOnly={!spolecnostRights.vychVolbyEdit}
                    />
                    {kartySpolecnostList.fetched ?
                        <KartyPanel
                            kartyList={kartySpolecnostList.rows}
                            spolecnost={spolecnost}
                            readOnly={!spolecnostRights.kartaEdit}
                        /> : <Loader />
                    }
                    {nakladovaStrediskaList.fetched ?
                        <NakladovaStrediskaPanel
                            nakladovaStrediskaList={nakladovaStrediskaList.rows}
                            spolecnost={spolecnost}
                            readOnly={!spolecnostRights.vychVolbyEdit}
                        /> : <Loader />
                    }
                    {spolecnostPobockyVydejList.fetched ?
                        <SpolecnostPobockaVydejPanel
                            spolecnostPobockyVydejList={spolecnostPobockyVydejList.rows}
                            spolecnost={spolecnost}
                            readOnly={role !== EnumRole.ADMIN}
                        /> : <Loader />
                    }
                </Col>
            </Row>}
        />
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        nakladovaStrediskaList: utils.storeFromArea(state, ciselnikActions.NAKLADOVA_STREDISKA_LIST_AREA),
        spolecnostPobockyVydejList: utils.storeFromArea(state, subjektActions.SPOLECNOST_POBOCKY_VYDEJ_LIST_AREA),
        spolecnostDetail: utils.storeFromArea(state, subjektActions.SPOLECNOST_DETAIL_AREA),
        spolecnostRightsDetail: utils.storeFromArea(state, subjektActions.SPOLECNOST_RIGHTS_AREA),
        uzivateleSpolecnostList: utils.storeFromArea(state, subjektActions.SPOLECNOST_ZAMESTNANCI_LIST_AREA),
        adresySpolecnostList: utils.storeFromArea(state, subjektActions.SPOLECNOST_ADRESY_LIST_AREA),
        kartySpolecnostList: utils.storeFromArea(state, subjektActions.SPOLECNOST_KARTY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(SpolecnostPage));

